import { useTranslation } from 'react-i18next';

import { OptionWrapper, Wrapper } from './GridOptionsSelector.styles';

type Props<T> = {
  value?: T;
  options: T[];
  onChange: (value: T) => void;
};

export const GridOptionsSelector = <T,>({ value, options, onChange }: Props<T>) => {
  const { t } = useTranslation();

  const handleChange = (newValue: T) => onChange(newValue);

  return (
    <Wrapper>
      {options.map(option => {
        const label = option === true ? t('YES') : option === false ? t('NO') : t(String(option));
        return (
          <OptionWrapper
            key={String(option)}
            onClick={() => handleChange(option)}
            selected={value === option}>
            {label}
          </OptionWrapper>
        );
      })}
    </Wrapper>
  );
};
